import {
  incrementChatAnimationCounter,
  setAnimationShownCountCookie,
  setPrevPathCookie,
} from 'shared/containers/ConsultantCianChat/utils/chatAnimationCounter';
import { isNewbuildingSelector } from 'shared/selectors/newbuilding';
import { TThunkAction, TThunkDispatch } from 'shared/types/redux';
import { actionGenerator } from 'shared/utils/redux';

export enum EConsultantCianChatActionTypes {
  OpenAutorisationMotivationPopup = 'consultantCianChat/autorisationMotivationPopupOpen',
  CloseAutorisationMotivationPopup = 'consultantCianChat/autorisationMotivationPopupClose',
  OpenChat = 'consultantCianChat/open',
  CloseChat = 'consultantCianChat/close',
  SetChatLoading = 'consultantCianChat/setChatLoading',
  OpenErrorMessage = 'consultantCianChat/OpenErrorMessage',
  CloseErrorMessage = 'consultantCianChat/CloseErrorMessage',
  setAnimationShownCountAction = 'consultantCianChat/setAnimationShownCountAction',
  SetAnimationDelayMs = 'consultantCianChat/setAnimationDelayMs',
  SetChatAnimationCounter = 'consultantCianChat/setChatAnimationCounter',
}

export const openConsultantCianChat = actionGenerator<EConsultantCianChatActionTypes.OpenChat, string>(
  EConsultantCianChatActionTypes.OpenChat,
);

export const closeConsultantCianChat = actionGenerator<EConsultantCianChatActionTypes.CloseChat, void>(
  EConsultantCianChatActionTypes.CloseChat,
);

/* istanbul ignore next */
export const onConsultantCianCloseNoAuth = () => (): TThunkAction => (dispatch: TThunkDispatch) => {
  dispatch(closeConsultantCianChat());
};

export const openAutorisationMotivationConsultantCianChat = actionGenerator<
  EConsultantCianChatActionTypes.OpenAutorisationMotivationPopup,
  void
>(EConsultantCianChatActionTypes.OpenAutorisationMotivationPopup);

export const closeAutorisationMotivationConsultantCianChat = actionGenerator<
  EConsultantCianChatActionTypes.CloseAutorisationMotivationPopup,
  void
>(EConsultantCianChatActionTypes.CloseAutorisationMotivationPopup);

export const setChatLoading = actionGenerator<EConsultantCianChatActionTypes.SetChatLoading, void>(
  EConsultantCianChatActionTypes.SetChatLoading,
);

export const openErrorMessage = actionGenerator<EConsultantCianChatActionTypes.OpenErrorMessage, void>(
  EConsultantCianChatActionTypes.OpenErrorMessage,
);

export const closeErrorMessage = actionGenerator<EConsultantCianChatActionTypes.CloseErrorMessage, void>(
  EConsultantCianChatActionTypes.CloseErrorMessage,
);

export const setAnimationShownCountAction = actionGenerator<
  EConsultantCianChatActionTypes.setAnimationShownCountAction,
  number
>(EConsultantCianChatActionTypes.setAnimationShownCountAction);

export const setAnimationDelayMs = actionGenerator<EConsultantCianChatActionTypes.SetAnimationDelayMs, number>(
  EConsultantCianChatActionTypes.SetAnimationDelayMs,
);

export const setChatAnimationCounter = actionGenerator<EConsultantCianChatActionTypes.SetChatAnimationCounter, number>(
  EConsultantCianChatActionTypes.SetChatAnimationCounter,
);

export const setAnimationShownCount =
  (count: number): TThunkAction =>
  (dispatch: TThunkDispatch) => {
    setAnimationShownCountCookie(count);
    dispatch(setAnimationShownCountAction(count));
  };

export const incrementAnimationDelayMs = (): TThunkAction => (dispatch: TThunkDispatch, getState) => {
  const state = getState();
  const currentDelayMs = state.consultantCianChat.animationDelayMs;
  dispatch(setAnimationDelayMs(currentDelayMs + 1));
};

export const incrementAnimationCounter = (): TThunkAction => {
  return (dispatch: TThunkDispatch, getState) => {
    const state = getState();
    const isNewbuildingsOnly = isNewbuildingSelector(state);

    if (isNewbuildingsOnly) {
      dispatch(incrementAnimationDelayMs());
      const newCounter = incrementChatAnimationCounter();
      dispatch(setChatAnimationCounter(newCounter));
      const currentPath = window.location.pathname + window.location.search;
      if (currentPath) {
        setPrevPathCookie(currentPath);
      }
    }
  };
};

export type TConsultantCianChatActions =
  | ReturnType<typeof openConsultantCianChat>
  | ReturnType<typeof closeConsultantCianChat>
  | ReturnType<typeof openAutorisationMotivationConsultantCianChat>
  | ReturnType<typeof closeAutorisationMotivationConsultantCianChat>
  | ReturnType<typeof openErrorMessage>
  | ReturnType<typeof setChatLoading>
  | ReturnType<typeof closeErrorMessage>
  | ReturnType<typeof setAnimationShownCountAction>
  | ReturnType<typeof setAnimationDelayMs>
  | ReturnType<typeof setChatAnimationCounter>;
